import Bounce from './bounce'
import Flash from './flash'
import Pulse from './pulse'
import RubberBand from './rubber-band'
import Shake from './shake'
import Swing from './swing'
import Tada from './tada'
import Wobble from './wobble'
import Jello from './jello'

export default {
  Bounce,
  Flash,
  Pulse,
  RubberBand,
  Shake,
  Swing,
  Tada,
  Wobble,
  Jello
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/attention-seekers/index.js